export enum Market {
  HK = 'HK',
  US = 'US',
  SH = 'SH',
  SZ = 'SZ'
}

export enum Spead {
  A = '01',
  B = '03',
  C = '04',
  D = '05',
}

export enum SpreadType {
  Sub,
  Add
}

function getStockPriceGapASub(currentPrice: number) {
  let priceGap = 0.001
  if (currentPrice >= 0.01 && currentPrice <= 0.25) {
    priceGap = 0.001
  } else if (currentPrice > 0.25 && currentPrice <= 0.5) {
    priceGap = 0.005
  } else if (currentPrice > 0.5 && currentPrice <= 10.0) {
    priceGap = 0.01
  } else if (currentPrice > 10.0 && currentPrice <= 20.0) {
    priceGap = 0.01
  } else if (currentPrice > 20.0 && currentPrice <= 50.0) {
    priceGap = 0.02
  } else if (currentPrice > 50.0 && currentPrice <= 100.0) {
    priceGap = 0.05
  } else if (currentPrice > 100.0 && currentPrice <= 200.0) {
    priceGap = 0.1
  } else if (currentPrice > 200.0 && currentPrice <= 500.0) {
    priceGap = 0.2
  } else if (currentPrice > 500.0 && currentPrice <= 1000.0) {
    priceGap = 0.5
  } else if (currentPrice > 1000.0 && currentPrice <= 2000.0) {
    priceGap = 1.0
  } else if (currentPrice > 2000.0 && currentPrice <= 5000.0) {
    priceGap = 2.0
  } else if (currentPrice > 5000.0 && currentPrice <= 9995.0) {
    priceGap = 5.0
  } else if (currentPrice > 9995.0) {
    priceGap = 5.0
  }
  return priceGap
}

function getStockPriceGapAAdd(currentPrice: number) {
  let priceGap = 0.001
  if (currentPrice >= 0.01 && currentPrice < 0.25) {
    priceGap = 0.001
  } else if (currentPrice >= 0.25 && currentPrice < 0.5) {
    priceGap = 0.005
  } else if (currentPrice >= 0.5 && currentPrice < 10.0) {
    priceGap = 0.01
  } else if (currentPrice >= 10.0 && currentPrice < 20.0) {
    priceGap = 0.01
  } else if (currentPrice >= 20.0 && currentPrice < 50.0) {
    priceGap = 0.02
  } else if (currentPrice >= 50.0 && currentPrice < 100.0) {
    priceGap = 0.05
  } else if (currentPrice >= 100.0 && currentPrice < 200.0) {
    priceGap = 0.1
  } else if (currentPrice >= 200.0 && currentPrice < 500.0) {
    priceGap = 0.2
  } else if (currentPrice >= 500.0 && currentPrice < 1000.0) {
    priceGap = 0.5
  } else if (currentPrice >= 1000.0 && currentPrice < 2000.0) {
    priceGap = 1.0
  } else if (currentPrice >= 2000.0 && currentPrice < 5000.0) {
    priceGap = 2.0
  } else if (currentPrice >= 5000.0 && currentPrice < 9995.0) {
    priceGap = 5.0
  } else if (currentPrice >= 9995.0) {
    priceGap = 5.0
  }
  return priceGap
}

// 获取港股证股价差
function getStockPriceGapA(currentPrice: number, spreadType: SpreadType) {
  switch (spreadType) {
    case SpreadType.Sub:
      return getStockPriceGapASub(currentPrice)
    case SpreadType.Add:
      return getStockPriceGapAAdd(currentPrice)
  }
}

  // 获取港股证股价差
function getStockPriceGapB(currentPrice: number, spreadType: SpreadType) {
  if (currentPrice >= 0.50 && currentPrice <= 9999.95) {
    return 0.05
  }
  return getStockPriceGapA(currentPrice, spreadType)
}

function getStockPriceGapDSub(currentPrice: number) {
  let priceGap = 0.001
  if (currentPrice >= 0.01 && currentPrice <= 1.0) {
    priceGap = 0.001
  } else if (currentPrice > 1.0 && currentPrice <= 5.0) {
    priceGap = 0.002
  } else if (currentPrice > 5.0 && currentPrice <= 10.0) {
    priceGap = 0.005
  } else if (currentPrice > 10.0 && currentPrice <= 20.0) {
    priceGap = 0.01
  } else if (currentPrice > 20.0 && currentPrice <= 100.0) {
    priceGap = 0.02
  } else if (currentPrice > 100.0 && currentPrice <= 200.0) {
    priceGap = 0.05
  } else if (currentPrice > 200.0 && currentPrice <= 500.0) {
    priceGap = 0.1
  } else if (currentPrice > 500.0 && currentPrice <= 1000.0) {
    priceGap = 0.2
  } else if (currentPrice > 1000.0 && currentPrice <= 2000.0) {
    priceGap = 0.5
  } else if (currentPrice > 2000.0 && currentPrice <= 9999.0) {
    priceGap = 1.0
  } else if (currentPrice > 9999.0) {
    priceGap = 1.0
  }
  return priceGap
}

function getStockPriceGapDAdd(currentPrice: number) {
  let priceGap = 0.001
  if (currentPrice >= 0.01 && currentPrice < 1.0) {
    priceGap = 0.001
  } else if (currentPrice >= 1.0 && currentPrice < 5.0) {
    priceGap = 0.002
  } else if (currentPrice >= 5.0 && currentPrice < 10.0) {
    priceGap = 0.005
  } else if (currentPrice >= 10.0 && currentPrice < 20.0) {
    priceGap = 0.01
  } else if (currentPrice >= 20.0 && currentPrice < 100.0) {
    priceGap = 0.02
  } else if (currentPrice >= 100.0 && currentPrice < 200.0) {
    priceGap = 0.05
  } else if (currentPrice >= 200.0 && currentPrice < 500.0) {
    priceGap = 0.1
  } else if (currentPrice >= 500.0 && currentPrice < 1000.0) {
    priceGap = 0.2
  } else if (currentPrice >= 1000.0 && currentPrice < 2000.0) {
    priceGap = 0.5
  } else if (currentPrice >= 2000.0 && currentPrice < 9999.0) {
    priceGap = 1.0
  } else if (currentPrice >= 9999.0) {
    priceGap = 1.0
  }
  return priceGap
}

  // 获取港股证股价差
function getStockPriceGapD(currentPrice: number, spreadType: SpreadType) {
  switch (spreadType) {
    case SpreadType.Sub:
      return getStockPriceGapDSub(currentPrice)
    case SpreadType.Add:
      return getStockPriceGapDAdd(currentPrice)
  }
}

export function getStockPriceGap(currentPrice: number, market: string, stc: string, spreadType: SpreadType) {
  if (market.toUpperCase() === Market.HK) {
    switch (stc) {
      case Spead.A:
      case Spead.C:
        return getStockPriceGapA(currentPrice, spreadType)

      case Spead.B:
        return getStockPriceGapB(currentPrice, spreadType)

      case Spead.D:
        return getStockPriceGapD(currentPrice, spreadType)

      default:
        return getStockPriceGapA(currentPrice, spreadType)
    }
  } else if (market.toUpperCase() === Market.US ||
      market.toUpperCase() === Market.SZ ||
      market.toUpperCase() === Market.SH) {
    return 0.01
  }
  return 0
}
